module.exports = __webpack_public_path__ + "img/m1.a2dea8f1.png";